/* eslint-disable */
import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
// import { Container } from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <Stack spacing={1}>
      {/* For variant="text", adjust the height via font-size */}
      <Skeleton variant="rounded" width="100%" height={60} />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={60}
        style={{ marginTop: 16 }}
      />
    </Stack>
  );
};

export default SkeletonLoading;
